import { DEFAULT_VALUE } from "@supplier/constants";

/** 格式化手机号,12345678900 => 123 4567 8900 */
export const formatPhone = (phone?: string) => {
    if (!phone) return DEFAULT_VALUE;
    return phone.replace(/(\d{3})(\d{4})(\d{4})/g, "$1 $2 $3");
};

/** 格式化手机号,用于输入中 */
export const formatterPhone = (value: string) => {
    if (!value || value.length <= 3) return value;
    if (value.length > 3 && value.length <= 7) return `${value.slice(0, 3)} ${value.slice(3)}`;
    return `${value.slice(0, 3)} ${value.slice(3, 7)} ${value.slice(7)}`;
};

/** 格式化银行账号,用于输入中,6311111111122231234 => 631 1111 1111 2223 1234 */
export const formatterBankAccount = (account: string) => {
    // 前3位后加空格，后面每4位字符后加一个空格
    let str = "";
    for (const [i, char] of Array.from(account).entries()) {
        str += char;
        if (i === 2 || (i > 2 && (i - 2) % 4 === 0)) {
            str += " ";
        }
    }
    return str.trimEnd();
};

/** 格式化银行账号,6311111111122231234 => 631 1111 1111 2223 1234 */
export const formatBankAccount = (account?: string) => {
    if (!account) return DEFAULT_VALUE;
    return formatterBankAccount(account);
};

/**
 * 格式化数字显示 1234.1 => 1,234.1
 * @param num 数字
 * @param unit 单位
 */
export const fmtNum = (num?: number | string, unit?: string) => {
    // 空值判断：undefined/null直接返回默认值
    if (num === undefined || num === null) return DEFAULT_VALUE;
    // 转数字+非数字判断：非有效数字返回默认值
    const numVal = Number(num);
    if (Number.isNaN(numVal)) return DEFAULT_VALUE;
    // 原生实现千分位格式化
    const formatStr = numVal.toLocaleString("en-US");
    // 拼接单位（无单位则空）返回
    return formatStr + (unit || "");
};

/**
 * 格式化金钱显示 1234.1 => 1,234.10
 * @param num 数字
 * @param unit 单位
 * @param format 小数点后位数
 */
export const fmtMoney = (num?: number | string, unit?: string, format: number = 2) => {
    // 1. 空值/非数字判断，返回默认值
    if (num === undefined || num === null) return DEFAULT_VALUE;
    const numStr = String(num).trim();
    if (numStr === "" || Number.isNaN(Number(numStr))) return DEFAULT_VALUE;

    // 2. 计算原数字的小数位数
    const decimalPlaces = numStr.includes(".") ? numStr.split(".")[1].length : 0;

    // 3. 智能计算最终保留的小数位（原逻辑完全不变）
    const decimals = format > 2 ? Math.min(Math.max(decimalPlaces, 2), format) : format;

    // 4. 原生实现「千分位+指定小数位」格式化
    const numVal = Number(numStr);
    const formatStr = numVal.toLocaleString("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: true // 强制千分位，与原逻辑一致
    });

    // 5. 拼接单位返回
    return formatStr + (unit || "");
};

/** 格式化输入框，数字显示 1234.1 => 1,234.1 */
export const fmtInputNum = (value: unknown) => {
    // 1. 非字符串/空字符串直接返回空（原逻辑前置判断）
    if (typeof value !== "string") return "";
    if (value === "") return ""; // 原value===undefined已被typeof过滤，无需重复判断
    // 2. 转数字校验：非有效数字返回空
    const numVal = Number(value);
    if (Number.isNaN(numVal)) return "";

    // 3. 保留原尾缀判断逻辑：. /.0 /.00 优先级从高到低
    let lastStr = value.endsWith(".") ? "." : "";
    lastStr = value.endsWith(".0") ? ".0" : lastStr;
    lastStr = value.endsWith(".00") ? ".00" : lastStr;

    // 4. 原生实现：保留2位小数→千分位格式化
    // toFixed(2) 保留2位小数（四舍五入）
    const fixed2 = numVal.toFixed(2);
    // 原生千分位格式化，处理保留2位后的数字
    const formatStr = Number(fixed2).toLocaleString("en-US");

    // 5. 拼接尾缀，兜底默认值（对齐原逻辑）
    return formatStr + lastStr || DEFAULT_VALUE;
};


